export default __webpack_public_path__ + "static/media/test.2f907c74.png";